import { Box, Typography } from '@mui/material'
import RolesWithHover from './RolesWithHover'

const SingleRole = ({ title, roles, customStyle }) => (
  <Box sx={[styles.infoBox, customStyle]}>
    <Typography>{title}</Typography>
    <RolesWithHover moduleName={title} roles={roles} />
  </Box>
)

const styles = {

  infoBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '.MuiTypography-root': {
      fontSize: { xs: '12px', sm: '14px' },
      color: 'text.hint',
    },
  },
}

export default SingleRole
